import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { forgotPasswordGetEmail, forgotPasswordUpdatePassword } from '../api';
import Button from '../components/core/Button';
import FormElement from '../components/core/FormElement';
import Wrapper from '../components/core/Wrapper';
import { handleApiGlobalError } from '../helpers/asyncActions';
import { useGlobalContext } from '../stores/global';

export default function RestorePassword(props: any) {
  const { register, handleSubmit, errors } = useForm();
  const [email, setEmail] = useState<string>();
  const [status, setStatus] = useState<'success' | 'error'>();
  const { dispatch } = useGlobalContext();
  const id = props.match?.params?.id;
  const code = props.match?.params?.code;

  useEffect(() => {
    if (!id || !code) return;

    dispatch({ type: 'SET_LOADING', payload: true });

    forgotPasswordGetEmail(id, code)
      .then((response) => response.data?.data?.user?.email)
      .then((email) => setEmail(email))
      .catch((err) => {
        setStatus('error');
        throw err;
      })
      .catch(handleApiGlobalError.bind(null, dispatch))
      .finally(() => dispatch({ type: 'SET_LOADING', payload: false }));
  }, []);

  const handleFormSubmit = ({ newPassword }: any) => {
    if (!email || !newPassword) return;

    dispatch({ type: 'SET_LOADING', payload: true });

    forgotPasswordUpdatePassword(id, code, { email, password: newPassword })
      .then(() => {
        setStatus('success');
        dispatch({
          type: 'SET_ALERT_MODAL',
          payload: {
            title: 'Contraseña actualizada',
            message: 'Tu contraseña ha sido actualizada correctamente',
          },
        });
      })
      .catch((err) => {
        setStatus('error');
        throw err;
      })
      .catch(handleApiGlobalError.bind(null, dispatch))
      .finally(() => dispatch({ type: 'SET_LOADING', payload: false }));
  };

  return (
    <Wrapper
      subHeader={{ title: 'Cambiar contraseña' }}
      contentProps={{
        style: { textAlign: 'center', maxWidth: 500, margin: '0 auto' },
      }}
    >
      {status === 'error' || status === 'success' ? (
        <Button label="Regresar" onClick={() => (location.href = '/')} />
      ) : (
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <FormElement
            name="newPassword"
            elementType="password"
            autoComplete="new-password"
            label="Nueva Contraseña"
            variant="outlined"
            error={
              errors.newPassword?.type === 'required'
                ? 'Contraseña obligatoria.'
                : errors.newPassword?.type === 'minLength'
                ? 'Tu contraseña debe tener al menos 8 caracteres.'
                : null
            }
            inputRef={register({ required: true, minLength: 8 })}
          />
          <Button type="submit" label="CAMBIAR CONTRASEÑA" />
        </form>
      )}
    </Wrapper>
  );
}
